import { render, staticRenderFns } from "./AskIcon.vue?vue&type=template&id=34d2091e&scoped=true&"
import script from "./AskIcon.vue?vue&type=script&lang=js&"
export * from "./AskIcon.vue?vue&type=script&lang=js&"
import style0 from "./AskIcon.vue?vue&type=style&index=0&id=34d2091e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d2091e",
  null
  
)

export default component.exports